import type { StatusColor } from '@ztechapps/common.contract'
import { OrderStatusEnum, StatusToneEnum } from '@ztechapps/common.contract'

export type OrderStatusDetailType = {
  description: string
  sort: number
  value: OrderStatusEnum
  disabled?: boolean
} & StatusColor

export type OrderStatusType = {
  inCart: OrderStatusDetailType
  quotation: OrderStatusDetailType
  order: OrderStatusDetailType
  inProcess: OrderStatusDetailType
  readyForPayment: OrderStatusDetailType
  paid: OrderStatusDetailType
  packing: OrderStatusDetailType
  shipped: OrderStatusDetailType
  inTransit: OrderStatusDetailType
  delivered: OrderStatusDetailType
  cancelled: OrderStatusDetailType
}

// Each custom color is a CSS custom property declared in libs/webui/util/src/Status/StatusColor.scss; it resolves only in a browser that has loaded that stylesheet.
export const OrderStatus: OrderStatusType = {
  inCart: {
    value: OrderStatusEnum.InCart,
    description: 'The item is still in cart',
    sort: 0,
    tone: StatusToneEnum.Draft,
  },
  quotation: {
    value: OrderStatusEnum.Quotation,
    description: 'The quotation for the order is added',
    sort: 1,
    color: 'var(--status-custom-blue)',
  },
  order: {
    value: OrderStatusEnum.Order,
    description: 'The sales will be mark as an order',
    sort: 2,
    color: 'var(--status-custom-rose)',
  },
  inProcess: {
    value: OrderStatusEnum.InProgress,
    description: 'The order is still being process/prepared',
    sort: 3,
    tone: StatusToneEnum.InProgress,
  },
  readyForPayment: {
    value: OrderStatusEnum.ReadyForPayment,
    description: 'The order preparation was done, and ready for payment from the buyer.',
    sort: 4,
    color: 'var(--status-custom-magenta)',
  },
  paid: {
    value: OrderStatusEnum.Paid,
    description: 'The order was paid by the customer',
    sort: 5,
    color: 'var(--status-custom-indigo)',
  },
  packing: {
    value: OrderStatusEnum.Packing,
    description: 'The order was being prepared or packed',
    sort: 6,
    color: 'var(--status-custom-brown)',
  },
  shipped: {
    value: OrderStatusEnum.Shipped,
    description: 'The order was ready and already shipped',
    sort: 7,
    color: 'var(--status-custom-violet)',
  },
  inTransit: {
    value: OrderStatusEnum.InTransit,
    description: 'The order is on the way.',
    sort: 8,
    color: 'var(--status-custom-orange)',
  },
  delivered: {
    value: OrderStatusEnum.Delivered,
    description: 'The order was received by the customer.',
    sort: 9,
    tone: StatusToneEnum.Active,
  },

  cancelled: {
    value: OrderStatusEnum.Cancelled,
    description: 'The order was cancelled by the customer or admin',
    sort: 10,
    tone: StatusToneEnum.Cancelled,
  },
}
